import React from 'react';
import Banner from '../../../components/Banner/Index';

const Img1 = 'https://cdn.nudus.app/Images/revestimientos/1.png'
const Img2 = 'https://cdn.nudus.app/Images/revestimientos/2.png'
const Img3 = 'https://cdn.nudus.app/Images/revestimientos/3.png'
const Img5 = 'https://cdn.nudus.app/Images/revestimientos/5.png'
const Img6 = 'https://cdn.nudus.app/Images/revestimientos/6.png'
const Img9 = 'https://cdn.nudus.app/Images/revestimientos/9.png'
const Img10 = 'https://cdn.nudus.app/Images/revestimientos/10.png'
const Img11 = 'https://cdn.nudus.app/Images/revestimientos/11.png'
const Img14 = 'https://cdn.nudus.app/Images/revestimientos/14.png'

const images = [Img1, Img2, Img3, Img5, Img6, Img9, Img10, Img11, Img14];

const Revestimientos = () => {
  return (
    <>
        <Banner title='Revestimientos'/>
        <div className='products-container'>
            <div className='submenu-products'>
                <div className='div-submenu'>
                    <h5>Revestimientos</h5>
                </div>
            </div>
            <div className='content-products-container'>
              <h4 style={{ fontWeight: '700', marginTop: '2px' }} className='title-placas'>Revestimientos</h4>
              <p>Contamos con una amplia línea de productos importados de alta calidad, pensados para brindar soluciones estéticas, funcionales y duraderas en todo tipo de espacios.</p>
              <p>Ofrecemos revestimientos tanto para interior como para exterior, con diseños modernos y materiales resistentes que se adaptan a distintos estilos y necesidades.</p>
              <p style={{ fontWeight: '700' }}>Disponibles:</p>
              <ul>
                <li><p className='p-cards-comp'><span>Pisos SPC</span></p></li>
                <li><p className='p-cards-comp'><span>Chapa de policarbonato</span></p></li>
                <li><p className='p-cards-comp'><span>Placas PVC símil mármol</span></p></li>
                <li><p className='p-cards-comp'><span>Placas símil piedra</span></p></li>
                <li><p className='p-cards-comp'><span>Perfiles WPC</span></p></li>
                <li><p className='p-cards-comp'><span>Siding WPC</span></p></li>
                <li><p className='p-cards-comp'><span>Wall panel interior</span></p></li>
                <li><p className='p-cards-comp'><span>Redes de Camuflaje</span></p></li>
                <li><p className='p-cards-comp'><span>Wall panel exterior</span></p></li>
                <li><p className='p-cards-comp'><span>Deck WPC</span></p></li>
              </ul>

              <p style={{ fontWeight: '700' }}>📎 Consultá los catálogos completos acá:</p>
              <ul>
                <li><p className='p-cards-comp'><a target='_blank' rel='noopener noreferrer' href='https://drive.google.com/file/d/1TdqspnlcYKVftJtLrn-DFPSMETs8-Owx/view?usp=sharing'>
                  Catalogo placas PVC:
                </a></p></li>

                <li><p className='p-cards-comp'><a target='_blank' rel='noopener noreferrer' href='https://drive.google.com/file/d/17P8ly2GgqRQz5XJMJowXhiXOCrwWZCwe/view?usp=sharing '>
                  Catalogo placas WPC:
                </a></p></li>

                <li><p className='p-cards-comp'><a target='_blank' rel='noopener noreferrer' href='https://drive.google.com/file/d/1qrUJ8LWCM036yce5hvRvDoH64EQ_3aLx/view?usp=sharing'>
                  Catálogo Redes de Camuflaje
                </a></p></li>

                <li><p className='p-cards-comp'><a target='_blank' rel='noopener noreferrer' href='https://www.faplaconline.com.ar/home/c/ar-faplac/ar-melaminas '>
                  Catálogo Melaminas Faplac
                </a></p></li>
              </ul>
              <div className='cards-placas-container space'>
                {images.map((image) => (
                  <div className='card-placas-30'>
                      <div className='marco-img'>
                          <div className='img-card'>
                              <img alt='placa1' src={image} loading='lazy'/>
                          </div>
                      </div>
                  </div>
                ))}
              </div>
            </div>
        </div>
    </>
  )
}


export default Revestimientos;
